import { FeatureFlags } from '../api/company/companies.models';
import { useGetMyCompanies } from './api/company.api';

const useFeatureFlags = (isEnabled = true) => {
  const { data: companies } = useGetMyCompanies(false, isEnabled);

  const f = companies?.[0]?.featureFlags;

  const featureFlags: FeatureFlags = {
    CommentStress: !!f && f?.CommentStress === true,
    CompanyAction: !!f && f?.CompanyAction === true,
    GamificationChallenges: !!f && f?.GamificationChallenges === true,
    GamificationLeaderboard: !!f && f?.GamificationLeaderboard === true,
    Harmonia: !!f && f?.Harmonia === true,
    PulseSurvey: !!f && f?.PulseSurvey === true,
  };

  return [featureFlags, !!featureFlags] as [FeatureFlags, boolean];
};

export default useFeatureFlags;
